import React from 'react';
import { GetIcon } from '../../../components/icons/Icons';

interface NavigationButtonProps {
    direction: 'prev' | 'next';
}

export const NavigationButton: React.FC<NavigationButtonProps> = ({ direction }) => (
    <div className={`swiper-button-${direction}`} data-testid={`nav-button-${direction}`}>
        <GetIcon
            name={
                direction === 'prev'
                    ? 'navigation-slide-arrow-left'
                    : 'navigation-slide-arrow-right'
            }
            size="md"
        />
    </div>
);
